<template>
  <div class="one-column-view">
    <div class="article-content">
      <div
        class="d-flex flex-column flex-md-row justify-content-around align-items-center mb-3"
      >
        <div class="w-100 w-md-35 p-0 p-md-3 mb-3">
          <img src="../../assets/GSG.png" alt="GSG" class="m-0 mx-auto w-100" />
        </div>
        <div class="w-100 w-md-65 p-0 p-md-3">
          <h1>什么是GSG?</h1>
          <p class="m-0">
            发现 GSG 的惊人潜力！GSG 是 Gold Strike GOLD
            的缩写。这是一个流量挖掘入口，可以增长到高级别奖励。通过
            GSG，矿工可以享受丰厚的 100% 直接流量挖掘奖励、诱人的 20%
            间接流量挖掘奖励以及额外的 10% 活动主持奖励。此外，GSG 还提供诱人的
            GEMA 奖励和令人兴奋的 NFT
            拍卖收入，从而确保矿工有多样化的收入来源。今天就加入
            GSG，开启通往无与伦比的收入之路！
          </p>
        </div>
      </div>
      <div
        class="d-flex flex-column flex-md-row justify-content-around align-items-center mb-3"
      >
        <div class="w-100 w-md-35 p-0 p-md-3 mb-3">
          <img
            src="../../assets/GEMA.png"
            alt="GSG"
            class="m-0 mx-auto w-100"
          />
        </div>
        <div class="w-100 w-md-65 p-0 p-md-3">
          <h1>什么是GEMA?</h1>
          <p class="m-0">
            GEMA 是全球独家营销代理的缩写，是授予 GSG 的一项尊贵特权。GEMA
            证书是GSG资格权利的延伸。当您获得GSG入门资格并向GoldenLink+推荐企业时，您就成为了该企业（即矿主或广告商）在GOLD平台上的营销代理，您将享有使用强大的GoldenLink+应用程序提高企业销售额的独家特权。这一认证不仅保证了无与伦比的支持，还为
            GSG带来了众多发展机遇：建立社交媒体联系、扩大影响力、提高流量转化率。
          </p>
        </div>
      </div>
      <h1>GSG 和 GEMA 证书</h1>
      <p>
        GoldenLink+平台的高级入口，为GoldenLink+用户提供商业营销货币化资质和奖励算法功能。与
        GSR
        相比，GSG或GEMA证书持有者可通过积极推广产品、服务和品牌，提高流量挖掘能力，享受更多优惠。
      </p>
      <h1>NFT 代币功能转让和拍卖</h1>
      <p>
        现在，GSG 和 GEMA
        证书的所有权转让可通过竞价拍卖或在线交易市场完成。GoldenLink+创新性地将传统证书资格扩展到NFT代币，实现了无缝转换为在线web3
        NFT代币拍卖或交易转让模式。通过购买 NFT 代币（GSG 或
        GEMA），这些证书的持有者可以通过将其与平台上的代币挂钩，轻松实现资质转让或拍卖。
      </p>
      <h1>为什么要拍卖？</h1>
      <p>
        在商业世界中，传统模式允许企业出售或拍卖其营销权。GoldenLink+
        是一个社交媒体平台，为企业提供了在网络社区转让或拍卖其营销资格以获取一定利益的机会。
      </p>
      <h1>获得更多益处</h1>
      <p>
        将您的 GSG 或 GEMA 证书资格与 GSG 或 GEMA NFT
        代币挂钩，并利用机会转让或拍卖您的资格，以获得更大的收益。
      </p>
      <h1>其他盈利方法</h1>
      <p>
        如果您不希望使用绑定证书和 NFT
        代币转让资格利益，您可以利用您在社区中的影响力，为您的品牌、产品或服务建立强大的追随者。与活跃参与者分享营销红利，作为营销领导者与公司协商获得更好的奖励，邀请更多成员加入您的社区，并努力推动成功的营销转化。根据自己的目标，参与者可以获得分享红利或营销奖励。
      </p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped></style>
